import { imgs } from "../../assets/imgs";

export const VolunteerCards = () => {
   const cards = [
      {
         title: 'Experience More Valuable Than Gold',
         content: 'Volunteering at the Summit is an adventure. You may never have a change to be in a similar experience.  Tell us what roles you’d like to undertake, what you’re good at, and we’ll help find a role that’s suitable!',
         img: imgs.volunteer.volunteerCards1,
      },
      {
         title: 'Make Valuable Connections',
         content: 'The Summit attracts leaders in their fields. Mingle with representatives from 100+ VC firms, world-class speakers from massive corporations, or meet the entrepreneurs shaping the future. Make connections that you’ll keep for years to come!',
         img: imgs.volunteer.volunteerCards2,
      },
      {
         title: 'Experience the Summit during your time off',
         content: 'As a volunteer, you’ll have full access to the entire Summit. Check out panels, Top Innovator Presentations, or head on over to the Expo floor and network.',
         img: imgs.volunteer.volunteerCards3,
      },
   ];
   return (
      <div className='volunteer-cards'>
         <div className='cards-container'>
            {
               cards.map((card, i) =>
                  <div className='card' key={i}>
                     <img src={card.img} alt="" />
                     <h4>{card.title}</h4>
                     <p>{card.content}</p>
                  </div>
               )
            }
         </div>
      </div>
   )
}
